<template>
    <div class="VTextArea">
    <textarea
        v-model="localValue"
        @input="input"
        :placeholder="placeholder"
        :rows="rows"
    >
    </textarea>
    </div>
</template>

<script>
    export default {
        name: 'VTextArea',
        model: {
            prop: 'value',
            event: 'input',
        },
        props: {
            value: {
                type: String,
                required: true,
            },
            placeholder: {
                type: String,
                required: false,
                default: '',
            },
            rows: {
                type: Number,
                required: false,
                default: 3,
            },
        },
        data() {
            return {
                localValue: '',
            };
        },
        watch: {
            value: {
                immediate: true,
                handler(newVal) {
                    if (JSON.stringify(newVal) !== JSON.stringify(this.localValue)) {
                        this.localValue = newVal;
                    }
                },
            },
            localValue: {
                handler(newVal) {
                    if (JSON.stringify(newVal) !== JSON.stringify(this.value)) {
                        this.$emit('input', newVal);
                    }
                },
            },
        },
        methods: {
            input() {
                this.$emit('change');
            },
        },
    };
</script>

<style
    scoped
    lang="scss"
>
    .VTextArea {
        width: 100%;
        textarea {
            height: calc(100% - 4px - 4px);
            padding: 2px 5px;
            outline: none;
            border: 2px solid $dark-blue-color;
            resize: none;
            width: calc(100% - 10px - 4px);
        }
    }
</style>
